// base
import { createSlice } from '@reduxjs/toolkit';


// actions
import { TBM_SLICE_NAME } from '../actions/tbm.action';

// initialState
const initialState = {
  tbmStatusList: []
};

// createSlice
const tbmSlice = createSlice({
  name: TBM_SLICE_NAME,
  initialState,
  reducers: {},
});

export const tbm = tbmSlice.name;
export const tbmReducer = tbmSlice.reducer;
export const tbmActions = tbmSlice.actions;
export default tbmSlice.reducer;
